import { selector } from "recoil";

import { API, graphqlOperation } from "aws-amplify";
import { listZonesBasic, getSchemeZoneConfig, getZoneBasic } from "../graphql/queries-custom";
import { selectedUserSchemeAtom, loggedInUserAtom } from "./user";
import { findTreeNodeByKey, getAllChildZones } from "../helpers/Zones";

export const tenantAccessibleResourcesSelector = selector({
	key: "tenantAccessibleResourcesSelector",
	get: async ({ get }) => {
		const scheme = get(selectedUserSchemeAtom);
		if (!scheme || scheme.role !== "TENANT") {
			return { zoneIds: null, deviceIds: null };
		}

		const loggedInUser = get(loggedInUserAtom);
		if (!loggedInUser?.sub) {
			return { zoneIds: [], deviceIds: [] };
		}

		const {
			data: {
				getScheme: { zoneConfig },
			},
		} = await API.graphql(graphqlOperation(getSchemeZoneConfig, { id: scheme.id }));
		const zoneTree = zoneConfig ? JSON.parse(zoneConfig) : [];

		const {
			data: {
				zoneBySchemeId: { items: tenantZones },
			},
		} = await API.graphql(
			graphqlOperation(listZonesBasic, {
				schemeId: scheme.id,
				filter: { tenant: { contains: loggedInUser.sub } },
			}),
		);

		const zoneIds = new Set();
		const deviceIds = new Set();

		const addDevices = (devices) => {
			if (!devices?.length) return;
			devices.forEach((device) => deviceIds.add(device.id));
		};

		for await (const tenantZone of tenantZones) {
			zoneIds.add(tenantZone.id);
			addDevices(tenantZone?.devices?.items);

			if (!zoneTree?.length) continue;
			const treeNode = await findTreeNodeByKey(zoneTree, tenantZone.id);
			if (!treeNode) continue;
			const childZoneIds = [];
			await getAllChildZones(treeNode, childZoneIds);
			for await (const childZoneId of childZoneIds) {
				if (!zoneIds.has(childZoneId)) zoneIds.add(childZoneId);
				const {
					data: { getZone: zoneDetails },
				} = await API.graphql(graphqlOperation(getZoneBasic, { id: childZoneId }));
				addDevices(zoneDetails?.devices?.items);
			}
		}

		return { zoneIds: Array.from(zoneIds), deviceIds: Array.from(deviceIds) };
	},
});
